import { EMPTY, Observable, throwError } from 'rxjs';
import { AjaxConfig, AjaxError, AjaxResponse } from 'rxjs/ajax';
import { catchError } from 'rxjs/operators';

import { HttpCodes } from 'app/constants/http-codes';
import { environment } from 'app/services/environment';
import { messagingService } from 'app/services/messaging.service';
import { AppStore } from 'app/store';
import { logoutUser } from 'features/auth/auth.slice';

import { HttpHandler } from '../http-handler';
import { Interceptor } from '../interceptor';

export class AuthRedirectInterceptor implements Interceptor {
    // invalid or expired token error
    private static readonly TOKEN_ERROR_A = 20;
    // token is in invalid format
    private static readonly TOKEN_ERROR_B = 10;

    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        return next.handle(req).pipe(
            catchError((error: AjaxError) => {
                if (AuthRedirectInterceptor.needsLogin(error)) {
                    // dispatch(refreshTokens()).subscribe((context) => {
                    //     if (!context.isValid()) {
                    //         dispatch(logoutUser());
                    //         window.location.href = `${environment.publicUrlPart}/login`;
                    //
                    //         return;
                    //     }
                    //     // we successfully refreshed
                    // }); TODO attempt to refresh token before redirecting to login
                    store.dispatch(logoutUser());
                    window.location.href = `${environment.publicUrlPart}/login`;

                    return EMPTY;
                }

                return throwError(() => error);
            }),
        );
    }

    private static needsLogin(error: AjaxError) {
        let devMessage = '';
        switch (error.status) {
            case HttpCodes.UNAUTHORIZED:
                return true;
            case HttpCodes.FORBIDDEN:
                try {
                    const body = (
                        'object' === typeof error.response ? error.response : JSON.parse(error.response as string)
                    ) as Record<string, unknown>;

                    if (
                        body.code === AuthRedirectInterceptor.TOKEN_ERROR_A ||
                        body.code === AuthRedirectInterceptor.TOKEN_ERROR_B
                    ) {
                        // special codes indicating something wrong with token  so we redirect user to login
                        return true;
                    }
                    devMessage = 'string' === typeof body.message ? body.message : '';
                } catch (err) {
                    // in case we got some strange error that was not json encoded
                }
                messagingService.showError(`Access Denied. ${devMessage}`);

                return false;
            default:
                return false;
        }
    }
}
